import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, Grid } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { FormattedMessage } from "react-intl";

export const LeaveSessionModal = ({ userRole, onLeaveSession, isOpen, onCancel }) => (
  <Modal
    width="auto"
    heigth="auto"
    isOpen={isOpen}
    id="dmstk-loading-modal"
    onModalClose={onCancel}
  >
    <Modal.Content>
      <Flex alignItems="center" flexDirection="column" justifyContent="center">
        <Modal.Title>
          <FormattedMessage id={`live_sessions.leaving_confirmation.${userRole}.title`} />
        </Modal.Title>
        <Modal.Content>
          <Text size="small" textAlign="center">
            <FormattedMessage id={`live_sessions.leaving_confirmation.${userRole}.subtitle`} />
          </Text>
        </Modal.Content>
        <Modal.Actions>
          <Grid
            gridTemplateColumns="1fr 1fr"
            gridTemplateRows="1fr"
            gridColumnGap={3}
            marginTop={5}
          >
            <Button size="medium" hollow="secondary" id="cancel-button">
              <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="sonar">
                <FormattedMessage id="generic.cancel" />
              </Text>
            </Button>
            <Button size="medium" action={onLeaveSession}>
              <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
                <FormattedMessage id={`live_sessions.leaving_confirmation.${userRole}.button`} />
              </Text>
            </Button>
          </Grid>
        </Modal.Actions>
      </Flex>
    </Modal.Content>
  </Modal>
);

LeaveSessionModal.propTypes = {
  userRole: PropTypes.string.isRequired,
  onLeaveSession: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default LeaveSessionModal;
